import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'
import { SeasonsPage } from './pages/SeasonsPage'
import { SeasonPage } from './pages/SeasonPage'
import { RacePage } from './pages/RacePage'
import { ComparePage } from './pages/ComparePage'
import { ConfigPage } from './pages/ConfigPage'
import { ConstructorPage, ConstructorsPage, DriverPage, DriversPage } from './pages/PeoplePages'
import { NotFoundPage } from './pages/NotFoundPage'
import {
  F15ChampionshipPage,
  F15ConstructorPage,
  F15DriverPage,
  F15DriversPage,
  F15RacePage,
  F15SeasonPage,
  F2ChampionshipPage,
  F2ConstructorPage,
  F2DriverPage,
  F2DriversPage,
  F2RacePage,
  F2SeasonPage,
  ReverseChampionshipPage,
  ReverseConstructorPage,
  ReverseDriverPage,
  ReverseDriversPage,
  ReverseRacePage,
  ReverseSeasonPage,
} from './pages/F2Pages'
import {
  BanChampionshipPage,
  BanConstructorsPage,
  BanConstructorPage,
  BanDriverPage,
  BanDriversPage,
  BanRacePage,
  BanSeasonPage,
  BanSelectPage,
} from './pages/BanPages'
import {
  PracticeChampionshipPage,
  PracticeConstructorPage,
  PracticeConstructorsPage,
  PracticeDriverPage,
  PracticeDriversPage,
  PracticeRacePage,
  PracticeSeasonPage,
} from './pages/PracticePages'
import {
  ScaleChampionshipPage,
  ScaleConstructorsPage,
  ScaleConstructorPage,
  ScaleDriverPage,
  ScaleDriversPage,
  ScaleRacePage,
  ScaleEditPage,
  ScaleSeasonPage,
} from './pages/ScalePages'
import {
  QualifyingChampionshipPage,
  QualifyingConstructorPage,
  QualifyingConstructorsPage,
  QualifyingDriverPage,
  QualifyingDriversPage,
  QualifyingRacePage,
  QualifyingSeasonPage,
} from './pages/QualifyingPages'

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="seasons" element={<SeasonsPage />} />
        <Route path="seasons/:year" element={<SeasonPage />} />
        <Route path="races/:year/:round" element={<RacePage />} />
        <Route path="drivers" element={<DriversPage />} />
        <Route path="drivers/:slug" element={<DriverPage />} />
        <Route path="constructors" element={<ConstructorsPage />} />
        <Route path="constructors/:slug" element={<ConstructorPage />} />
        <Route path="f2/championship" element={<F2ChampionshipPage />} />
        <Route path="f2/drivers" element={<F2DriversPage />} />
        <Route path="f2/drivers/:slug" element={<F2DriverPage />} />
        <Route path="f2/constructors/:slug" element={<F2ConstructorPage />} />
        <Route path="f2/races/:year/:round" element={<F2RacePage />} />
        <Route path="f2/season" element={<F2SeasonPage />} />
        <Route path="f15/championship" element={<F15ChampionshipPage />} />
        <Route path="f15/drivers" element={<F15DriversPage />} />
        <Route path="f15/drivers/:slug" element={<F15DriverPage />} />
        <Route path="f15/constructors/:slug" element={<F15ConstructorPage />} />
        <Route path="f15/races/:year/:round" element={<F15RacePage />} />
        <Route path="f15/season" element={<F15SeasonPage />} />
        <Route path="reverse/championship" element={<ReverseChampionshipPage />} />
        <Route path="reverse/drivers" element={<ReverseDriversPage />} />
        <Route path="reverse/drivers/:slug" element={<ReverseDriverPage />} />
        <Route path="reverse/constructors/:slug" element={<ReverseConstructorPage />} />
        <Route path="reverse/races/:year/:round" element={<ReverseRacePage />} />
        <Route path="reverse/season" element={<ReverseSeasonPage />} />
        <Route path="ban" element={<BanSelectPage />} />
        <Route path="ban/championship" element={<BanChampionshipPage />} />
        <Route path="ban/drivers" element={<BanDriversPage />} />
        <Route path="ban/drivers/:slug" element={<BanDriverPage />} />
        <Route path="ban/constructors/:slug" element={<BanConstructorPage />} />
        <Route path="ban/races/:year/:round" element={<BanRacePage />} />
        <Route path="ban/constructors" element={<BanConstructorsPage />} />
        <Route path="ban/season" element={<BanSeasonPage />} />
        <Route path="points" element={<ScaleEditPage />} />
        <Route path="points/championship" element={<ScaleChampionshipPage />} />
        <Route path="points/drivers" element={<ScaleDriversPage />} />
        <Route path="points/drivers/:slug" element={<ScaleDriverPage />} />
        <Route path="points/constructors/:slug" element={<ScaleConstructorPage />} />
        <Route path="points/races/:year/:round" element={<ScaleRacePage />} />
        <Route path="points/constructors" element={<ScaleConstructorsPage />} />
        <Route path="points/season" element={<ScaleSeasonPage />} />
        <Route path="qualifying/championship" element={<QualifyingChampionshipPage />} />
        <Route path="qualifying/drivers" element={<QualifyingDriversPage />} />
        <Route path="qualifying/drivers/:slug" element={<QualifyingDriverPage />} />
        <Route path="qualifying/constructors/:slug" element={<QualifyingConstructorPage />} />
        <Route path="qualifying/races/:year/:round" element={<QualifyingRacePage />} />
        <Route path="qualifying/constructors" element={<QualifyingConstructorsPage />} />
        <Route path="qualifying/season" element={<QualifyingSeasonPage />} />
        <Route path="fp/championship" element={<PracticeChampionshipPage />} />
        <Route path="fp/drivers" element={<PracticeDriversPage />} />
        <Route path="fp/drivers/:slug" element={<PracticeDriverPage />} />
        <Route path="fp/constructors/:slug" element={<PracticeConstructorPage />} />
        <Route path="fp/races/:year/:round" element={<PracticeRacePage />} />
        <Route path="fp/constructors" element={<PracticeConstructorsPage />} />
        <Route path="fp/season" element={<PracticeSeasonPage />} />
        <Route path="compare" element={<ComparePage />} />
        <Route path="config" element={<ConfigPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
